import {ActionReducerMap} from '@ngrx/store';
import {routerReducer} from '@ngrx/router-store';
import {IAppState} from '@app/core/store/state/app.state';
import {errorReducers} from '@app/core/store/reducers/error.reducers';
import {payrollsReducers} from '@app/core/store/reducers/payrolls.reducers';
import {newSalaryExportReducers} from '@app/core/store/reducers/new-salary-export.reducers';
import {scheduleReducers} from '@app/core/store/reducers/schedule.reducers';
import {shiftDraftsReducers} from '@app/core/store/reducers/shift-drafts.reducers';
import {layoutReducers} from '@app/core/store/reducers/layout.reducers';
import {departmentSettingsReducers} from '@app/core/store/reducers/department-settings.reducers';
import {subscriptionReducers} from '@app/core/store/reducers/subscription.reducers';
import {sessionReducers} from '@app/core/store/reducers/session.reducers';
import {dayNotesReducers} from '@app/core/store/reducers/daynotes.reducers';
import {statisticsReducers} from '@app/core/store/reducers/statistics.reducers';
import {shiftTemplatesReducers} from '@app/core/store/reducers/shift-templates.reducers';
import {employeesReducers} from '@app/core/store/reducers/employees.reducers';
import {notificationsReducers} from '@app/core/store/reducers/notifications.reducers';
import {availabilitiesReducers} from '@app/core/store/reducers/availabilities.reducers';
import {bulletinBoardReducers} from '@app/core/store/reducers/bulletin-board.reducers';
import {fileEntryReducers} from '@app/core/store/reducers/file-entry.reducers';
import {actionsReducers} from '@app/core/store/reducers/actions.reducers';
import {activityReducers} from '@app/core/store/reducers/activity.reducers';
import {departmentReducers} from '@app/core/store/reducers/department.reducers';
import {messagesReducers} from '@app/core/store/reducers/messages.reducers';
import {integrationsReducers} from '@app/core/store/reducers/integrations.reducers';
import {supplementalSalaryReducers} from '@app/core/store/reducers/supplementalSalary.reducers';
import {dashboardReducers} from '@app/core/store/reducers/dashboard.reducers';
import {punchClockReducers} from '@app/core/store/reducers/punch-clock.reducers';
import {sickDaysReducers} from '@app/core/store/reducers/sick-days.reducers';

export const appReducers: ActionReducerMap<IAppState, any> = {
	router: routerReducer,
	error: errorReducers,
	payrolls: payrollsReducers,
	department: departmentReducers,
	newSalaryExport: newSalaryExportReducers,
	schedule: scheduleReducers,
	shiftDrafts: shiftDraftsReducers,
	layout: layoutReducers,
	departmentSettings: departmentSettingsReducers,
	subscription: subscriptionReducers,
	session: sessionReducers,
	dayNotes: dayNotesReducers,
	statistics: statisticsReducers,
	shiftTemplates: shiftTemplatesReducers,
	employees: employeesReducers,
	notifications: notificationsReducers,
	availabilities: availabilitiesReducers,
	actions: actionsReducers,
	activity: activityReducers,
	messages: messagesReducers,
	bulletinBoard: bulletinBoardReducers,
	fileEntry: fileEntryReducers,
	integrations: integrationsReducers,
	supplementalSalary: supplementalSalaryReducers,
	dashboard: dashboardReducers,
	punchClock: punchClockReducers,
	sickDays: sickDaysReducers,
};
